import { render, staticRenderFns } from "./AppointmentActivity.vue?vue&type=template&id=3638154d&scoped=true"
import script from "./AppointmentActivity.vue?vue&type=script&lang=js"
export * from "./AppointmentActivity.vue?vue&type=script&lang=js"
import style0 from "./AppointmentActivity.vue?vue&type=style&index=0&id=3638154d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638154d",
  null
  
)

export default component.exports